import { usePortalPermissions } from "@hooks/usePortalPermissions";
import type { Feature, PermissionLevel } from "@lyteflo/types";
import { ComponentChildren } from "preact";

interface WithPermissionProps {
  children: ComponentChildren;
  feature?: Feature;
  features?: Feature[];
  requireAll?: boolean;
  requiredLevel?: PermissionLevel;
  canManage?: boolean;
  targetLevel?: PermissionLevel;
}

export const WithPermission = ({
  children,
  feature,
  features,
  requireAll = false,
  requiredLevel,
  canManage,
  targetLevel,
}: WithPermissionProps) => {
  const {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    canAccessLevel,
    canManageLevel,
  } = usePortalPermissions();

  // Check feature-based permissions
  if (feature && !hasPermission(feature)) {
    return null;
  }

  if (features?.length) {
    if (requireAll && !hasAllPermissions(features)) {
      return null;
    }
    if (!requireAll && !hasAnyPermission(features)) {
      return null;
    }
  }

  // Check level-based permissions
  if (requiredLevel !== undefined && !canAccessLevel(requiredLevel)) {
    return null;
  }

  if (canManage && targetLevel !== undefined && !canManageLevel(targetLevel)) {
    return null;
  }

  return <>{children}</>;
};
